import { render, staticRenderFns } from "./threshold.vue?vue&type=template&id=4f2a17a1&scoped=true&"
import script from "./threshold.vue?vue&type=script&lang=ts&"
export * from "./threshold.vue?vue&type=script&lang=ts&"
import style0 from "./threshold.vue?vue&type=style&index=0&id=4f2a17a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a17a1",
  null
  
)

export default component.exports